import { render } from "./Badge.vue?vue&type=template&id=382f1eec&scoped=true"
import script from "./Badge.vue?vue&type=script&lang=js"
export * from "./Badge.vue?vue&type=script&lang=js"

import "./Badge.vue?vue&type=style&index=0&id=382f1eec&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382f1eec"]])

export default __exports__